module.exports = __webpack_public_path__ + "bin/03bafd056945612296b5f86dcc9fa479.jpg";